var Gainsight = (function(backOffice, $) {
    
    backOffice.Integration.Gainsight = (function() {
        var scopeSelector = backOffice.options.scopeSelector;
        var gainsightKey, clientId, retailAccount, userCode, firstName, lastName, segment, win, doc, appVersion, userPermission;
        var operatingSystemVersion = "";

        /**
         * Best-effort OS string for Gainsight user attribute OperatingSystemVersion.
         * Windows release names like "25H2" are not exposed to web pages; Chromium reports
         * platformVersion (e.g. 15.0.0) which we map to Windows 10 / Windows 11 where possible.
         */
        function resolveOperatingSystemVersion() {
            return new Promise(function (resolve) {
                var nav = window.navigator;
                if (nav.userAgentData && typeof nav.userAgentData.getHighEntropyValues === "function") {
                    nav.userAgentData.getHighEntropyValues(["platform", "platformVersion", "architecture", "model"])
                        .then(function (hints) {
                            resolve(formatOsFromClientHints(hints, nav.userAgentData.platform));
                        })
                        .catch(function () {
                            resolve(fallbackOsFromUserAgent());
                        });
                } else {
                    resolve(fallbackOsFromUserAgent());
                }
            });
        }

        function formatOsFromClientHints(hints, lowEntropyPlatform) {
            var platform = (hints && hints.platform) || lowEntropyPlatform || "";
            var pv = (hints && hints.platformVersion) || "";
            var arch = (hints && hints.architecture) || "";
            var model = (hints && hints.model) || "";
            var parts = [];

            if (/^Win/i.test(platform)) {
                parts.push(mapWindowsDisplayName(pv));
                if (pv) {
                    parts.push("Version " + pv);
                }
            } else if (/^macOS$/i.test(platform) || /^Mac/i.test(platform)) {
                parts.push("macOS");
                if (pv) {
                    parts.push("Version " + pv);
                }
            } else if (platform) {
                parts.push(platform);
                if (pv) {
                    parts.push("Version " + pv);
                }
            }

            var tail = [];
            if (arch) {
                tail.push(arch);
            }
            if (model && !/^generic$/i.test(model)) {
                tail.push(model);
            }
            var main = parts.join(" ").trim();
            var extra = tail.length ? " (" + tail.join(", ") + ")" : "";
            var result = (main + extra).trim();
            return result || fallbackOsFromUserAgent();
        }

        function mapWindowsDisplayName(platformVersion) {
            var major = parseInt(String(platformVersion).split(".")[0], 10);
            if (isNaN(major)) {
                return "Windows";
            }
            if (major >= 13) {
                return "Windows 11";
            }
            if (major === 10) {
                return "Windows 10";
            }
            if (major > 0 && major < 10) {
                return "Windows";
            }
            return "Windows";
        }

        function fallbackOsFromUserAgent() {
            var ua = (window.navigator && window.navigator.userAgent) || "";
            if (/Windows NT 10\.0/i.test(ua)) {
                return "Windows NT 10.0";
            }
            if (/Windows NT 6\.3/i.test(ua)) {
                return "Windows 8.1";
            }
            if (/Windows NT 6\.2/i.test(ua)) {
                return "Windows 8";
            }
            if (/Windows NT 6\.1/i.test(ua)) {
                return "Windows 7";
            }
            var mac = ua.match(/Mac OS X ([\d_]+)/i);
            if (mac) {
                return "macOS " + mac[1].replace(/_/g, ".");
            }
            if (/Android/i.test(ua)) {
                var av = ua.match(/Android ([\d.]+)/i);
                return av ? "Android " + av[1] : "Android";
            }
            if (/Linux/i.test(ua)) {
                return "Linux";
            }
            if (/iPhone|iPad|iPod/i.test(ua)) {
                var os = ua.match(/OS ([\d_]+)/i);
                return os ? "iOS " + os[1].replace(/_/g, ".") : "iOS";
            }
            return ua ? "Unknown (" + ua.substring(0, 120) + ")" : "Unknown";
        }

        
        var isLoaded = {
            get: function() {
                return $("#gainsightLoaded", scopeSelector).val();
            },
            set: function() {
                $("#gainsightLoaded", scopeSelector).val("true");
            },
            init: function() {
                //create a hidden element to store whether the Gainsight is loaded or not
                if (!$("#gainsightLoaded", scopeSelector).length) {
                    $('<input type="hidden" id="gainsightLoaded" value="false" />').prependTo(scopeSelector);
                }
            }
        }
        
        var loadGainsight = function() {
            if (isLoaded.get() !== "true") {
                isLoaded.set();

                // Gainsight PX Tag
                (function (n, t, a, e, x) {   
                        let i = "aptrinsic"; n[i] = n[i] || function () {
                                (n[i].q = n[i].q || []).push(arguments)
                            }, 
                            n[i].p = e, n[i].c = x;
    
                        let r = t.createElement("script");
                        r.async = !0;
                        r.src = a + "?a=" + e;        
    
                        let c = t.getElementsByTagName("script")[0];
                        c.parentNode.insertBefore(r, c);
                    })
                    (win, doc, "https://web-sdk.aptrinsic.com/api/aptrinsic.js", gainsightKey, { "iframeModeEnabled": false });
                // End Gainsight PX Tag    
            }
        }
        
        var identify = function() {
            var applyIdentify = function() {
                var userPayload = {
                    "id": clientId + "-" + userCode,
                    "firstName": firstName,
                    "lastName": lastName,
                    "userPermission": userPermission
                };
                if (operatingSystemVersion) {
                    userPayload.OperatingSystemVersion = operatingSystemVersion;
                }
                aptrinsic("identify",
                    userPayload,
                    {
                        "id": clientId,
                        "name": retailAccount,
                        "releaseSegment": (segment || "").replace(/^\/|\/$/g, "").substring(0, 2),
                        "appVersion": appVersion
                    });
            };

            if (operatingSystemVersion) {
                applyIdentify();
                return;
            }
            resolveOperatingSystemVersion().then(function (os) {
                operatingSystemVersion = os || "";
                applyIdentify();
            });
        }
        
        var initialise = function(options) {
            $.extend(backOffice.options, options);
            scopeSelector = backOffice.options.scopeSelector;
            gainsightKey = options.gainsightKey;
            clientId = options.clientId;
            retailAccount = options.retailAccount;
            userCode = options.userCode;
            firstName = options.firstName;
            lastName = options.lastName;
            segment = options.segment;
            win = options.win;
            doc = options.doc;
            appVersion = getAppVersionFromSourceBranch(options.sourceBranch);

            if (options.isAdmin != null && options.isAdmin != undefined) {
                userPermission = options.isAdmin ? "admin user" : "user";
            }
            loadGainsight();

            resolveOperatingSystemVersion().then(function (os) {
                operatingSystemVersion = os || "";
                if (BackOffice.Utils.GetCookie("ReX_CallBackLogin")) {
                    BackOffice.Utils.SetCookie("ReX_CallBackLogin", null, 1);
                    identify();
                }
            });
            
            isLoaded.init();
        }

        var logout = function(){
            if(window.aptrinsic){
                window.aptrinsic('reset');
            }
        }

        function getAppVersionFromSourceBranch(sourceBranch) {
            if (!sourceBranch)
                return 'N/A';
            else {
                var branchParts = sourceBranch.split('/');
                return branchParts[branchParts.length - 1];
            }
        }

        return $.extend(backOffice.Integration.Gainsight,
            {
                Init: initialise,
                Identify: identify,
                Logout: logout
            });
    })();
    return backOffice.Integration.Gainsight;
})(BackOffice || {}, jQuery);